export const FETCHED_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCHING_PRODUCT = 'FETCHING_PRODUCT';
export const SET_GEORESOURCES = 'SET_GEORESOURCES';
export const SETTING_FT_ELIGIBLE = 'SETTING_FT_ELIGIBLE';
export const FT_ELIGIBLE_SET = 'FT_ELIGIBLE_SET';